module.exports = __webpack_public_path__ + "static/logo-BWNC-20f239a5fba1f65fbb004f4650e15b67.jpg";